import { Injectable, inject } from '@angular/core';
import { ApiService, Industry, Investment, Location } from '@franbase/shared/data-access';
import { ComponentStore } from '@ngrx/component-store';
import { EMPTY, catchError, map, switchMap, tap } from 'rxjs';
interface CategoryState {
  loading: boolean,
  error: string,
  industry: Industry[],
  location: Location[],
  investment: Investment[]
}
const initialState: CategoryState = {
  loading: false,
  error: '',
  industry: [],
  location: [],
  investment: []
}

@Injectable({
  providedIn: 'root'
})
export class CategoryStoreService extends ComponentStore<CategoryState> {

  apiSV = inject(ApiService);

  constructor() { super(initialState); }

  loading$ = this.select((s) => s.loading);
  error$ = this.select((s) => s.error);
  industry$ = this.select((s) => s.industry as Industry[]);
  location$ = this.select((s) => s.location as Location[]);
  investment$ = this.select((s) => s.investment as Investment[]);

  loadCategory$ = this.effect(none$ => {
    return none$.pipe(
      tap(() => this.patchState({ loading: true, error: '' })),
      switchMap(() => {
        return this.apiSV.getAllCategories();
      }),
      map((rs: any) => {
        this.patchState({
          loading: false,
          error: '',
          industry: rs.industry.sort((a: any, b: any) => (a.title >= b.title) ? 1 : -1),
          location: rs.location.sort((a: any, b: any) => (a.title >= b.title) ? 1 : -1),
          investment: rs.investment.sort((a: any, b: any) => (a.title >= b.title) ? 1 : -1)
        })
      }),
      catchError(err => {
        this.patchState({ loading: false, error: err as string });
        return EMPTY;
      })
    )
  });

}
